import React from 'react';

export default function Spacing({ lg = '_', sm = '_' }) {
  return <div className={`docpro_height_lg_${lg} docpro_height_${sm}`}></div>;
}
